import { ADJUSTER_REPORT_BASE_PATH } from '@/config/baseModulesLink';

export const ADJUSTER_REPORT_BODY_DAMAGE_PATHS = {
  INFORMATION: {
    base: 'body-damage-information',
    DRIVER_OWNER: {
      EDIT: {
        driver: 'driver-info',
        certificate: 'certificate-information',
        driverContact: 'contact-info',
        owner: 'owner-info',
        ownerContact: 'owner-contact-info',
      },
      show: 'show',
    },
    VEHICLE_INFORMATION: {
      EDIT: { base: 'vehicle-information', partTwo: 'part-two' },
      show: 'show-vehicle-information',
    },
    EXPERT: {
      base: 'expert',
      visitInformation: 'visit-information',
      visitInformationShow: 'show-visit-information',
      wages: 'wages',
      wagesShow: 'show-wages',
      substitutionParts: 'substitution-parts',
      substitutionPartsForm: 'form',
      substitutionPartsShow: 'show-substitution-parts',
      costs: 'costs',
      costsShow: 'show-costs',
    },
    BANK_ACCOUNT: { edit: 'bank-account', show: 'show-bank-account' },
    PROPERTY_INSURANCE: {
      edit: 'property-insurance',
      show: 'show-property-insurance',
    },
  },
  IMAGES: {
    base: 'body-damage-images',
    ADJUSTER: {
      base: 'adjuster',
      DOCUMENT: { edit: 'document', show: 'show-document' },
      ADDITIONAL: { edit: 'attached', show: 'show-attached' },
      VEHICLE: {
        base: 'vehicle',
        serverDamagedPoints: 'server-damaged-points',
        takePhotoGuide: 'take-photo-guide',
        imageFlow: 'image-flow',
        imageFlowSignature: 'signature',
        previewImages: 'preview-images',
        serverPreviewImages: 'server-preview-images',
        showServerPreviewImages: 'show-server-preview-images',
      },
    },
    CUSTOMER: {
      base: 'customer',
      vehicleImages: 'vehicle',
      document: 'document',
      additional: 'attached',
    },
    SIGNATURE: { edit: 'signature', show: 'show-signature' },
    corrective: 'corrective',
  },
} as const;

export const ADJUSTER_REPORT_BODY_DAMAGE_LINKS = {
  BODY_DAMAGE_INFORMATION: ({ id }: { id: number | string }) => {
    const BODY_DAMAGE_INFORMATION =
      ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION;
    const informationBase = `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${BODY_DAMAGE_INFORMATION.base}`;
    const expertBase = `${informationBase}/${BODY_DAMAGE_INFORMATION.EXPERT.base}`;

    return {
      bodyDamageInformationTabsPage: informationBase,
      DRIVER_OWNER_INFORMATION: {
        driver: `${informationBase}/${BODY_DAMAGE_INFORMATION.DRIVER_OWNER.EDIT.driver}`,
        certificate: `${informationBase}/${BODY_DAMAGE_INFORMATION.DRIVER_OWNER.EDIT.driver}/${BODY_DAMAGE_INFORMATION.DRIVER_OWNER.EDIT.certificate}`,
        driverContact: `${informationBase}/${BODY_DAMAGE_INFORMATION.DRIVER_OWNER.EDIT.driver}/${BODY_DAMAGE_INFORMATION.DRIVER_OWNER.EDIT.driverContact}`,
        owner: `${informationBase}/${BODY_DAMAGE_INFORMATION.DRIVER_OWNER.EDIT.owner}`,
        ownerContact: `${informationBase}/${BODY_DAMAGE_INFORMATION.DRIVER_OWNER.EDIT.owner}/${BODY_DAMAGE_INFORMATION.DRIVER_OWNER.EDIT.ownerContact}`,
        show: `${informationBase}/${BODY_DAMAGE_INFORMATION.DRIVER_OWNER.show}`,
      },
      VEHICLE_INFORMATION: {
        partOne: `${informationBase}/${BODY_DAMAGE_INFORMATION.VEHICLE_INFORMATION.EDIT.base}`,
        partTwo: `${informationBase}/${BODY_DAMAGE_INFORMATION.VEHICLE_INFORMATION.EDIT.base}/${BODY_DAMAGE_INFORMATION.VEHICLE_INFORMATION.EDIT.partTwo}`,
        show: `${informationBase}/${BODY_DAMAGE_INFORMATION.VEHICLE_INFORMATION.show}`,
      },
      EXPERT: {
        entryTabs: expertBase,
        visitInformation: `${expertBase}/${BODY_DAMAGE_INFORMATION.EXPERT.visitInformation}`,
        visitInformationShow: `${expertBase}/${BODY_DAMAGE_INFORMATION.EXPERT.visitInformationShow}`,
        wages: `${expertBase}/${BODY_DAMAGE_INFORMATION.EXPERT.wages}`,
        wagesShow: `${expertBase}/${BODY_DAMAGE_INFORMATION.EXPERT.wagesShow}`,
        substitutionParts: `${expertBase}/${BODY_DAMAGE_INFORMATION.EXPERT.substitutionParts}`,
        substitutionPartsForm: `${expertBase}/${BODY_DAMAGE_INFORMATION.EXPERT.substitutionParts}/${BODY_DAMAGE_INFORMATION.EXPERT.substitutionPartsForm}`,
        substitutionPartsShow: `${expertBase}/${BODY_DAMAGE_INFORMATION.EXPERT.substitutionPartsShow}`,
        costs: `${expertBase}/${BODY_DAMAGE_INFORMATION.EXPERT.costs}`,
        costsShow: `${expertBase}/${BODY_DAMAGE_INFORMATION.EXPERT.costsShow}`,
      },
      BANK_ACCOUNT: {
        edit: `${informationBase}/${BODY_DAMAGE_INFORMATION.BANK_ACCOUNT.edit}`,
        show: `${informationBase}/${BODY_DAMAGE_INFORMATION.BANK_ACCOUNT.edit}/${BODY_DAMAGE_INFORMATION.BANK_ACCOUNT.show}`,
      },
      PROPERTY_INSURANCE: {
        edit: `${informationBase}/${BODY_DAMAGE_INFORMATION.PROPERTY_INSURANCE.edit}`,
        show: `${informationBase}/${BODY_DAMAGE_INFORMATION.PROPERTY_INSURANCE.edit}/${BODY_DAMAGE_INFORMATION.PROPERTY_INSURANCE.show}`,
      },
    };
  },
  BODY_DAMAGE_IMAGES: ({ id }: { id: number | string }) => {
    const BODY_DAMAGE_IMAGES = ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES;
    const imagesBase = `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${BODY_DAMAGE_IMAGES.base}`;
    const adjusterImagesBase = `${imagesBase}/${BODY_DAMAGE_IMAGES.ADJUSTER.base}`;
    const adjusterVehicleBase = `${adjusterImagesBase}/${BODY_DAMAGE_IMAGES.ADJUSTER.VEHICLE.base}`;
    const customerImagesBase = `${imagesBase}/${BODY_DAMAGE_IMAGES.CUSTOMER.base}`;

    return {
      imagesTabPage: imagesBase,
      adjusterImagesTabsPage: adjusterImagesBase,
      customerImagesTabsPage: customerImagesBase,
      ADJUSTER_VEHICLE: {
        damagedPoints: adjusterVehicleBase,
        serverDamagedPoints: `${adjusterVehicleBase}/${BODY_DAMAGE_IMAGES.ADJUSTER.VEHICLE.serverDamagedPoints}`,
        takePhotoGuide: `${adjusterVehicleBase}/${BODY_DAMAGE_IMAGES.ADJUSTER.VEHICLE.takePhotoGuide}`,
        imageFlow: `${adjusterVehicleBase}/${BODY_DAMAGE_IMAGES.ADJUSTER.VEHICLE.imageFlow}`,
        previewImages: `${adjusterVehicleBase}/${BODY_DAMAGE_IMAGES.ADJUSTER.VEHICLE.previewImages}`,
        serverPreviewImages: `${adjusterVehicleBase}/${BODY_DAMAGE_IMAGES.ADJUSTER.VEHICLE.serverPreviewImages}`,
        showServerPreviewImages: `${adjusterVehicleBase}/${BODY_DAMAGE_IMAGES.ADJUSTER.VEHICLE.showServerPreviewImages}`,
      },
      ADJUSTER_DOCUMENT: {
        edit: `${adjusterImagesBase}/${BODY_DAMAGE_IMAGES.ADJUSTER.DOCUMENT.edit}`,
        show: `${adjusterImagesBase}/${BODY_DAMAGE_IMAGES.ADJUSTER.DOCUMENT.show}`,
      },
      ADJUSTER_ADDITIONAL: {
        edit: `${adjusterImagesBase}/${BODY_DAMAGE_IMAGES.ADJUSTER.ADDITIONAL.edit}`,
        show: `${adjusterImagesBase}/${BODY_DAMAGE_IMAGES.ADJUSTER.ADDITIONAL.show}`,
      },
      customerVehicle: `${customerImagesBase}/${BODY_DAMAGE_IMAGES.CUSTOMER.vehicleImages}`,
      customerDocument: `${customerImagesBase}/${BODY_DAMAGE_IMAGES.CUSTOMER.document}`,
      customerAdditional: `${customerImagesBase}/${BODY_DAMAGE_IMAGES.CUSTOMER.additional}`,
      SIGNATURE: {
        edit: `${imagesBase}/${BODY_DAMAGE_IMAGES.SIGNATURE.edit}`,
        show: `${imagesBase}/${BODY_DAMAGE_IMAGES.SIGNATURE.show}`,
      },
      corrective: `${imagesBase}/${BODY_DAMAGE_IMAGES.corrective}`,
    };
  },
};
